import * as React from 'react';

import { sections } from 'components/lexemes';
import { CdnImagePath } from 'lib/cdn-image-path';
import { useDetectPrint } from 'lib/use-detect-print';

import { PageSectionTwoColumnsImageLeftColumn } from 'components/page/sections/page-section-two-columns-image-left-column';
import {
  SectionContentLinkList,
  SectionContentLinkListIdOne,
} from 'components/section-content-link-list';
import { P1 } from 'components/typography';

export const TabOneContainer: React.FC = () => {
  const itemListLexemes = sections.tabOneSection.tab.contents.list();
  const list = [
    {
      id: SectionContentLinkListIdOne.RegistrationInformation,
      text: itemListLexemes[0],
    },
    {
      id: SectionContentLinkListIdOne.LinkedSocialMediaInformation,
      text: itemListLexemes[1],
    },
    {
      id: SectionContentLinkListIdOne.ProfileVerificationInformation,
      text: itemListLexemes[2],
    },
    {
      id: SectionContentLinkListIdOne.PurchaseInformation,
      text: itemListLexemes[3],
    },
    {
      id: SectionContentLinkListIdOne.GeolocationInformation,
      text: itemListLexemes[4],
    },
    {
      id: SectionContentLinkListIdOne.DeviceInformation,
      text: itemListLexemes[5],
    },
    {
      id: SectionContentLinkListIdOne.PhotoInformation,
      text: itemListLexemes[6],
    },
    {
      id: SectionContentLinkListIdOne.LinkInformation,
      text: itemListLexemes[7],
    },
    {
      id: SectionContentLinkListIdOne.Messages,
      text: itemListLexemes[11],
    },
    {
      id: SectionContentLinkListIdOne.BumbleSuccessStories,
      text: itemListLexemes[8],
    },
    {
      id: SectionContentLinkListIdOne.CustomerSupportContactInformation,
      text: itemListLexemes[9],
    },
    {
      id: SectionContentLinkListIdOne.CookiesAndSimilarTechnologyInformation,
      text: itemListLexemes[10],
    },
  ];
  const isPrinting = useDetectPrint();
  const props = {
    title: sections.tabOneSection.tab.title(),
    subTitle: sections.tabOneSection.tab.text(),
    image: isPrinting
      ? undefined
      : {
          src: `${CdnImagePath}/assets/tab-01/tab-01-01.jpg`,
          objectPosition: '50% 33%',
          inlinePosition: 'start',
        },
    columnLeft: {
      contentBefore: (
        <div className="speech-box speech-box--relatively-full-width speech-box--soft-white speech-box--over-next">
          <P1 as="p">{sections.tabOneSection.tab.speechBox()}</P1>
        </div>
      ),
    },
    columnRight: {
      title: sections.tabOneSection.tab.contents.title(),
      content: <SectionContentLinkList list={list} />,
    },
  };

  return <PageSectionTwoColumnsImageLeftColumn {...props} />;
};
